import React from 'react';
import { Badge } from '../ui/badge';

const statusConfig = {
  // Dossier statuses
  en_cours: { label: 'En cours', variant: 'default', className: 'bg-blue-100 text-blue-700 border-blue-200' },
  termine: { label: 'Terminé', variant: 'default', className: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  annule: { label: 'Annulé', variant: 'default', className: 'bg-red-100 text-red-700 border-red-200' },
  abandon: { label: 'Abandon', variant: 'default', className: 'bg-amber-100 text-amber-700 border-amber-200' },
  
  // Document statuses
  brouillon: { label: 'Brouillon', variant: 'default', className: 'bg-slate-100 text-slate-700 border-slate-200' },
  envoye: { label: 'Envoyé', variant: 'default', className: 'bg-sky-100 text-sky-700 border-sky-200' },
  signe: { label: 'Signé', variant: 'default', className: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  paye: { label: 'Payé', variant: 'default', className: 'bg-green-100 text-green-700 border-green-200' },
  
  // Formateur statuses
  salarie: { label: 'Salarié', variant: 'default', className: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
  vacataire: { label: 'Vacataire', variant: 'default', className: 'bg-amber-100 text-amber-700 border-amber-200' },
  
  // Formation types
  presentiel: { label: 'Présentiel', variant: 'default', className: 'bg-violet-100 text-violet-700 border-violet-200' },
  distanciel: { label: 'Distanciel', variant: 'default', className: 'bg-cyan-100 text-cyan-700 border-cyan-200' },
  mixte: { label: 'Mixte', variant: 'default', className: 'bg-purple-100 text-purple-700 border-purple-200' },
  elearning: { label: 'E-learning', variant: 'default', className: 'bg-teal-100 text-teal-700 border-teal-200' },
  afest: { label: 'AFEST', variant: 'default', className: 'bg-orange-100 text-orange-700 border-orange-200' },
  
  // Roles
  admin: { label: 'Admin', variant: 'default', className: 'bg-red-100 text-red-700 border-red-200' },
  formateur: { label: 'Formateur', variant: 'default', className: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
  candidat: { label: 'Candidat', variant: 'default', className: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
};

export const StatusBadge = ({ status, className = '' }) => {
  const config = statusConfig[status] || { 
    label: status, 
    variant: 'default', 
    className: 'bg-slate-100 text-slate-700 border-slate-200' 
  };

  return (
    <Badge 
      variant={config.variant} 
      className={`${config.className} ${className} border font-medium`}
    >
      {config.label}
    </Badge>
  );
};
